<template>
  <!-- 订单详情 -->
  <div class="order">
    <div class="order_card" v-if="conference.conference.cover_url">
      <section>
        <img :src="conference.conference.cover_url" alt />
        <span v-if="conference.conference.start_time > new Date().getTime()">{{conference.conference.start_time > new Date().getTime() ? ((conference.conference.start_time - new Date().getTime())/(24 * 3600 * 1000)+'天后开始'):'' }}</span>
      </section>
      <div>
        <div class="t">
          <p  class="o_o">{{conference.conference.name}}</p>
          <van-tag round type="primary" size="large" v-if="conference.conference.type = 1">会议</van-tag>
          <van-tag round type="primary" size="large" v-else-if="conference.conference.type = 2">沙龙</van-tag>
          <van-tag round type="primary" size="large" v-else-if="conference.conference.type = 3">活动</van-tag>
        </div>
        <div class="o_t">
          <span class="iconfont"  >&#xe67f;</span>{{conference.conference.start_time,'Y-M-D'|formatDates}} ~ {{conference.conference.end_time,'Y-M-D'|formatDates}}
        </div>
        <div class="o_f">
          <span class="iconfont">&#xe64d;</span>{{conference.conference.region}} {{conference.conference.specific_address}}
        </div>
      </div>
    </div>
    <div class="order_num">
      <van-row>
        <van-col span="13">账单总金额:</van-col>
        <van-col span="6" offset="5" style="text-align: right;">￥{{order_box.order_info.amount}}</van-col>
      </van-row>
      <van-row>
        <van-col span="13">会议门票:</van-col>
        <van-col span="6" offset="5" class="co">{{order_box.order_info.goods_num}}</van-col>
      </van-row>
      <van-row>
        <van-col span="13">实付金额:</van-col>
        <van-col span="6" offset="5" class="co">￥{{order_box.order_info.amount}}</van-col>
      </van-row>
    </div>
    <div class="order_num_two">
      <van-row>
        <van-col span="5" class="fo">订单编号:</van-col>
        <van-col span="19" offset="0" style="text-align: right;" class="fo">
          <div style="display:inline" id="va">{{order_no}}</div>
          <span @click.stop.prevent="copy($event)" ref="copyBtn" style="margin-left:10px">复制</span>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="13">订单状态:</van-col>
        <van-col span="10" offset="1" class="co" :style="order_box.order_info.order_status == 'application' ? 'color:#ee0a24':''">
           {{order_box.order_info.order_status_str}}
          <span style="color:#ee0a24;cursor: pointer;" @click.stop="backMoney" v-if="order_box.order_info.order_status == 'finished'">退款</span>
        </van-col>
      </van-row>
      <van-row v-if="order_box.order_info.order_status == 'reject'">
        <van-col span="13">驳回原因:</van-col>
        <van-col span="10" offset="1" class="co" style="color:#ee0a24">
          {{order_box.order_info.note}}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="7">订单时间:</van-col>
        <van-col span="12" offset="5" class="co">{{order_box.order_info.start_time,'Y-M-D h:m:s'|formatDates}}</van-col>
      </van-row>
      <van-row v-if="order_box.order_info.pay_time">
        <van-col span="7">支付时间:</van-col>
        <van-col span="12" offset="5" class="co">{{order_box.order_info.pay_time,'Y-M-D h:m:s'|formatDates}}</van-col>
      </van-row>
      <van-row v-if="order_box.order_info.pay_type">
        <van-col span="13">支付方式:</van-col>
        <van-col span="4" offset="7" class="co">{{order_box.order_info.pay_type}}</van-col>
      </van-row>
      <van-row v-if="order_box.order_info.order_status == 'finished' && conference.conference.is_invoice == 1">
        <van-col span="13">开票:</van-col>
        <van-col span="10" offset="1" class="co">
          <template v-if="Object.keys(order_box.invoice).length == 0">
            <span style="color:#ee0a24;cursor: pointer;" @click.stop="goaddfapiao">去开票</span>
          </template>
          <span>
            <template v-if="order_box.invoice.status == 1">
待审核 <router-link class="nav-link blue" :to="'/invoiceInfo/'+order_box.invoice.id"><span class="text">查看详情</span></router-link>
            </template>
            <template v-if="order_box.invoice.status == 2">
审核未通过 <router-link class="nav-link blue" :to="'/invoiceInfo/'+order_box.invoice.id"><span class="text">查看详情</span></router-link>
            </template>
            <template v-if="order_box.invoice.status == 3">
审核通过  <router-link class="nav-link blue" :to="'/invoiceInfo/'+order_box.invoice.id"><span class="text">查看详情</span></router-link>
            </template>
            <template v-if="order_box.invoice.status == 4">
已取消 <span style="color:#ee0a24;cursor: pointer;" @click.stop="goaddfapiao">重新开票</span>
            </template>
          </span>
        </van-col>
      </van-row>
    </div>
    <!-- 主会议 -->
    <div class="hy_order" v-if="conference.data.length > 0">
      <div class="div">
        <span class="order_title">主会议  <span class="myIndex" @click="myIndex" v-if="showSeat">我的座位</span></span>
        <div class="order_list">
          <template v-for="(items,index) in conference.data">
            <template v-for="(items2,index2) in items.member">
              <van-row class="order_items">
                <van-col span="24">
                  <van-row>
                    <van-col span="12">
                      <div class="imgbox">
                        <img src="/static/images/member_default1.png" alt />
                      </div>
                      <p>{{items2.name == '' ? '未填写':items2.name}}</p>
                    </van-col>
                    <van-col span="12" class="r" style="text-align: right;">
                      <span class="span" style="color:black">{{items2.tel == '' ? '未填写': items2.tel}}</span>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col span="24" style="padding-top:10px">
                  <van-row>
                    <van-col span="14" class="tick">
                      <p>{{items.ticket.name}}</p>
                    </van-col>
                    <van-col span="8" class="r2">
                      <span class="span active" v-if="items2.use_status == 2"  @click="goadd(0,[index,index2])">去填写 ></span>
                      <template  v-if="order_box.order_info.order_status == 'finished'  || order_box.order_info.order_status == 'reject' || order_box.order_info.order_status == 'application'">
                        <span class="span active" v-if="items2.use_status == 0" @click="goPath('/ticket/'+items2.id)" >查看报名信息 ></span>
                        <span class="span" v-if="items2.use_status == 1" @click="goPath('/ticket/'+items2.id)">已使用 ></span>
                        <span class="span" v-if="items2.use_status == 3"  @click="goPath('/ticket/'+items2.id)">已过期></span>
                      </template>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- 平行会议 -->
        <div class="meet_order hy_order"  v-if="order_box.parallel.length >0">
          <div class="div">
            <span class="order_title">平行会议 <span class="myIndex" @click="myIndex" v-if="showSeat">我的座位</span></span>
            <p class="op">平行会议“参会人信息”可在【个人中心-我的会议】中补交</p>
            <div class="order_list">
              <template v-for="(items,index) in order_box.parallel">
                    <h5 class="px_title">{{items.conference.name}}</h5>
                   <template v-for="(items2,index2) in items.data">
                     <template v-for="(items3,index3) in items2.member">
                  <van-row class="order_items">
                    <van-col span="24">
                      <van-row>
                        <van-col span="12">
                          <div class="imgbox">
                            <img src="/static/images/member_default1.png" alt />
                          </div>
                          <p>
                            {{items3.use_status == 2 ? '未填写':items3.name}}
                          </p>
                        </van-col>
                        <van-col span="12" class="r" style="text-align: right;">
                          <span class="span" style="color:black">
                            {{items3.use_status == 2 ? '未填写':items3.tel}}
                          </span>
                        </van-col>
                      </van-row>
                    </van-col>
                    <van-col span="24">
                      <van-row>
                        <van-col span="14" class="tick">
                          <p>{{items2.ticket.name}}</p>
                        </van-col>
                        <van-col span="8" class="r2" >
                          <span class="span active" v-if="items3.use_status == 2"  @click="goadd(1,[index,index2,index3])">去填写 ></span>
                          <template  v-if="order_box.order_info.order_status == 'finished' || order_box.order_info.order_status == 'reject' || order_box.order_info.order_status == 'application'">
                          <span class="span active" v-if="items3.use_status == 0" @click="goPath('/ticket/'+items3.id)">查看报名信息 ></span>
                          <span class="span" v-if="items3.use_status == 1" @click="goPath('/ticket/'+items3.id)">已使用 ></span>
                          <span class="span" v-if="items3.use_status == 3"  @click="goPath('/ticket/'+items3.id)">已过期></span>
                        </template>
                        </van-col>
                      </van-row>
                    </van-col>
                  </van-row>
                   </template>
                 </template>
              </template>
            </div>

          </div>
        </div>
        <!-- 住宿费用 -->
      <div class="hotels_order hy_order"  v-if="order_box.hotel.length != 0">
          <div class="div">
            <span class="order_title">住宿费用</span>
            <div class="hotel_list">
              <template v-for="(items,index) in order_box.hotel">
                <template v-for="(items2,index2) in items.member">
                  <div class="hotel_item">
                    <van-row class="h_namebox">
                      <van-col span="16">
                        <p class="h_name">
                          <span class="icon_y"></span>{{items.hotel.h_name}} - {{items.hotel.hotel_type}}
                        </p>
                      </van-col>
                      <van-col span="8" class="r2">
                        <span class="span">
                          <template v-if="items.hotel.price != '0.00'">
                            ￥{{items.hotel.price}}
                          </template>
                          <template v-else>
                            预订
                          </template>
                          × 1</span>
                      </van-col>
                    </van-row>
                    <p class="h_time">{{items2.start_time,'Y-M-D'|formatDates}}入住，{{items2.end_time,'Y-M-D'|formatDates}}离店，共{{moment(items2.end_time * 1000).diff(moment(items2.start_time * 1000), 'day')}}晚</p>
                    <div class="list">
                      <van-row>
                        <van-col span="18">入住人信息: {{items2.name.name1 == '' ? '暂无':items2.name.name1}}</van-col>
                        <van-col span="6" class="r2">
                          <span class="span active" v-if="items2.name.name1 != ''"  @click="goPath('/orderPerfect2/'+ items2.id)">去修改 ></span>
                          <span class="span active" v-else @click="goPath('/orderPerfect2/'+ items2.id)">去填写 ></span>
                        </van-col>
                      </van-row>
                      <van-row v-if="items.hotel.member_num > 1">
                        <van-col span="18">入住人信息: {{items2.name.name2 == '' ? '暂无':items2.name.name2}}</van-col>
                        <van-col span="6"  class="r2">
                          <span class="span active" v-if="items2.name.name2 != ''"  @click="goPath('/orderPerfect2/'+items2.id)">去修改 ></span>
                          <span class="span active" v-else @click="goPath('/orderPerfect2/'+items2.id)">去填写 ></span>
                       </van-col>
                      </van-row>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <!-- 就餐费用 -->
      <div class="hotels_order hy_order"  v-if="order_box.repast.length != 0">
          <div class="div">
            <span class="order_title">就餐费用</span>
            <div class="hotel_list">
              <template v-for="(items,index) in order_box.repast">
                <div class="hotel_item">
                  <van-row class="h_namebox">
                    <van-col span="16">
                      <p class="h_name">
                        <span class="icon_y"></span>{{items.data.address}}
                      </p>
                    </van-col>
                    <van-col span="8" class="r2">
                      <span class="span"> {{items.data.quantity}}人就餐</span>
                    </van-col>
                  </van-row>
                  <p class="h_time">就餐时间：{{items.data.start_time,'Y-M-D h:m'|formatDates}} ~ {{items.data.end_time,'Y-M-D h:m'|formatDates}}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
    <div class="meet_order hy_order" v-if="order_box.order_info.pay_type == '线下'">
      <div class="div">
        <span class="order_title">汇款信息</span>
        <div class="op" v-html="conference.conference.remittance_info"></div>
      </div>
    </div>
    <!-- 会议说明 -->
   <div class="meet_order hy_order">
     <div class="div">
       <span class="order_title">报名须知</span>
       <div class="op" v-html="conference.conference.ticket_desc"></div>
      </div>
    </div>

    <!--浮动按钮-->
    <template v-if="Object.keys(conference.conference).length != 0">
      <footerFixed :id="conference.conference.id" :jump-page="conference.conference.jump_page"/>
    </template>

    <van-dialog v-model="tuikuan" :title="conference?.conference.refund_reminder == ''?'退款原因':'温馨提示'" show-cancel-button :before-close="CloseKa">
      <div class="tuikuan_tips" v-if="conference?.conference.refund_reminder != ''">
        {{conference?.conference.refund_reminder}}
      </div>
      <van-field v-model="tuiText" label="" placeholder="请输入退款原因" class="kaInput" v-else/>
    </van-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard"; //复制粘贴
import { formatDates ,formatWeekDate } from "../../assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  import moment from 'moment'

  export default {
    components: {
      footerFixed
    },
  data() {
    return {
      moment,
      id:'',
      order_no:'',
      tuikuan:false,
      tuiText:'',
      footerNav: false,
      order_box:{
        hotel:[
        ],
        order_info:{},
        parallel:[],
        repast:[],
        parallel_status:false
      },//订单详情
      conference:{
        conference:{},
        data:[]
      },//主会议
      order_amount:'',
      footerNav: false,
      showSeat:false
    };
  },
  /* 时间过滤 */
  filters: {
    formatDates,//调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
    formatWeekDate //
  },
  created: function(){
    var _this = this;
    _this.order_no = _this.$route.params.order_no;
    var getStorage = JSON.parse(sessionStorage.getItem('huiyi_orderlist'));
    _this.loadEnroll();
  },
  mounted() {
    var _this = this;
    /* 复制订单号 */
    setTimeout(function(){
      let text = document.getElementById("va").innerText;
      _this.clipboard = new Clipboard(_this.$refs.copyBtn, {
        text: () => text
      });
    },1000)
  },
  methods: {
    getTips(){
      var _this = this;
      let url = "/ac1/conference/seat/tips";
      let params = {
        id: _this.order_box.conference.conference.id
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          if(!res.posts.is_open || res.posts == ''){
            _this.showSeat = false;
          }else{
            _this.showSeat = true;
          }
        } else {
          _this.$toast(res.msg);
        }
      }, function(res) {
        console.log(res.msg);
      });
    },
    //退款
    backMoney(){
      var _this =this;
      _this.tuikuan = true;
    },
  async  CloseKa(action, done){
      var _this =this;
      if(action == 'confirm'){
        if(_this.tuiText == '' && _this.conference.conference.refund_reminder == ''){
           _this.$toast('退款原因不能为空！')
          done(false); 
          return false;
        } 
        let url = "/ac1/conference/refund";//退款原因
          let params = {
            order_on:_this.order_no,
            reason:_this.tuiText
          };
         _this.$post(url, params).then(res => {
            if (res.code == "1") {
              _this.$toast('您的退款信息已提交，您的退款申请小编已经进入审核！');
              _this.tuikuan = false;
            }else{
              _this.$toast(res.msg);
            }
          },function(res){
            console.log(res.msg);
          });
      } 
      if(action == 'cancel'){
        done();
      }
    },
    myIndex(){
      var _this = this;
      _this.$router.push('/seatList/'+_this.order_no);
      //_this.$toast('会议当天可查询座位详情信息');
    },
    //跳转去补充信息
    pay_type_to_str(pay_type){
        if (pay_type == 'purse')
          return "余额";
        if (pay_type == 'gold')
          return "金币";
        if (pay_type == 'alipay')
          return "支付宝";
        if (pay_type == 'unipay')
          return "银联";
        if (pay_type == 'wxpay')
          return "微信";
        if (pay_type == 'offline')
          return "线下";
        if (pay_type == 'paycard')
          return "充值卡";
        if (pay_type == 'admin')
          return "管理员";
        if (pay_type == 'system')
          return "系统自动";
    },
    //打开底部链接
    openFooterNav(val) {
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    },
    /* 复制订单号 */
    copy(event) {
      this.clipboard.on("success", e => {
        this.$toast("复制成功");
      });
      this.clipboard.on("error", e => {
        this.$toast("复制失败");
      });
    },
    loadEnroll(){
      var _this = this;
      let url = "/ac1/conference/orderDetail";
      let params = {
        order_no:_this.order_no
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          _this.order_box = res.posts;
          if( _this.order_box.conference.length != 0){
            _this.conference = _this.order_box.conference;
            var con = _this.order_box.conference.data.length;
            if(con >0){
              _this.hy_name = _this.order_box.conference.conference.name;
            }
          }else{
            _this.conference.conference = res.posts.parallel[0].conference;
          }
          _this.order_amount = _this.order_box.order_info.amount;
          _this.order_box.order_info.pay_type =  _this.pay_type_to_str(_this.order_box.order_info.pay_type);
          _this.id = _this.order_box.conference.conference.id;
          //设置微信分享
          _this.wxShare();
          _this.getTips();
          /*循环平行会议字段*/
         /* _this.order_box.parallel.forEach((v,index) => {
            v.forEach((s,index2) => {
              for(var i=0;i<(s.ticket.quantity - s.member.length);i++){
                _this.order_box.parallel[index][index2].member.push({
                  name:'',
                  tel:'',
                  use_status:1
                })
               }
            })
          })*/
        }else{
          _this.$toast(res.msg);
        }
      },function(res){
        console.log(res.msg);
      });


    },
    //设置微信分享
    wxShare(){
      var _this = this;
      let url2 = "/ac1/conference/confDetail";
      let params2 = {
        id: _this.id
      };
      _this.$get(url2, params2).then(res => {
        var share_box = res.posts.share_info;
        var wxShareInfo ={
          title:share_box.title,
          info:share_box.desc,
          shareurl:share_box.link,
          img:share_box.img
        };
        var  shareData = {
          data: wxShareInfo,//分享配置信息
          ifshare: true,
          that: _this
        };
        sessionStorage.setItem('hy_shareData'+_this.id,JSON.stringify(wxShareInfo));
        _this.$WXConfig.wxShowMenu(shareData);
      });
    },
    //去查看票详情
    goPath(path) {
      this.$router.push(path)
    },
    //去填写参会信息
    goadd(i,n) {
      var _this = this;
      if(i == 0){
        var cbox= _this.order_box.conference;
        var _thisbox = {c_id:cbox.conference.id,t_id:cbox.data[n[0]].ticket.id,order_no:_this.order_no,has_id:cbox.data[n[0]].member[n[1]].id};
      }else{
        var pbox= _this.order_box.parallel;
        var _thisbox = {c_id:pbox[n[0]].conference.id,t_id:pbox[n[0]].data[n[1]].ticket.id,order_no:_this.order_no,has_id:''};
      }
      sessionStorage.setItem('order_isok_'+_thisbox.t_id,JSON.stringify(_thisbox));
      this.$router.push('/orderperfect/'+_thisbox.t_id);
    },

    //开发票
    goaddfapiao(){
      var _this = this;
      var order_no = '',
          allAmount = 0,
          dep_code = '',
          code = '';
      order_no =_this.order_no;
      allAmount = parseFloat(allAmount) + parseFloat(_this.order_box.order_info.amount);
      dep_code = _this.order_box.order_info.dep_code;
      code = _this.order_box.conference.conference.code;
      localStorage.setItem('invoiceMenu', JSON.stringify({
        order_no: order_no,
        allAmount: allAmount,
        dep_code: dep_code,
        code: code
      }));
      _this.$router.push('/addInvoice');
    }
  }
};
</script>
<style lang="less">
  table{
    width: 100%!important;
  }
  .tuikuan_tips{
    width: 100%;
    padding: 30px;
    font-size: 28px;
    color: #ee0a24;
  }
  .kaInput{
    width: 100%;
    input{
      width: 100%;
      height: 70px;
      line-height: 70px;
      margin: 20px 0px;
      text-align: left;
      border: 1px solid #f1f1f1;
      font-size: 30px;
      padding: 0 10px;
    }
  }
</style>
<style lang="less" scoped>
  //订单详情页
  .order {
    width: 100%;
    min-height: 100vh;
    background: #f8f8f8;
    font-size: 28px;
    /* 复制成功弹出框 */
    overflow: hidden;
    .sz {
      font-size: 30px;
      background-color: #fe6333;
      height: 60px;
    }
    .order_card {
      width: 690px;
      box-shadow: 2px 5px 15px 5px #ebebeb;
      border-radius: 15px;
      margin: 30px auto;
      section {
        width: 100%;
       // height: 280px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 100%;
        //  height: 280px;
        }
        span {
          display: inline-block;
          position: absolute;
          right: 0;
          top: 20px;
          width: 157px;
          height: 43px;
          background-color: #fe6333;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          text-align: center;
          line-height: 43px;
          color: white;
          font-size: 26px;
        }
      }
      >div {
        padding: 0px 18px 0px 30px;
        margin-top: 30px;
        overflow: hidden;
        .t{
          width: 100%;
          overflow: hidden;
          margin-bottom: 20px;
          .o_o {
            // font-weight: 600;
            color: black;
            font-size: 30px;
            overflow: hidden;
            width:80%;
            float: left;
            padding: 0px;
            line-height: 35px;
          }
          .van-tag{
            float: right;
            line-height: 35px;
            background: #e8f6fc;
            color: #1eaafc;
            border-radius: 15px;
            padding: 0 15px;
            font-size: 22px;
          }
        }
        >div{
          margin-bottom: 20px;
          color: #959595;
          font-size: 26px;
          line-height: 30px;
          span{
            font-size:30px;
            margin:0px 3px 0px 0px;
            vertical-align: middle
          }
        }
      }
    }
    .order_num {
      width: 100%;
      margin-top: 36px;
      border-bottom: 1px solid rgb(182, 184, 181);
      .van-row > {
        padding: 0 30px;
        margin-bottom: 20px;
        // font-weight: 600;
        .co {
          color: #f95d34;
          text-align: right;
        }
      }
    }
    .order_num_two {
      width: 100%;
      margin-top: 30px;
      .van-row > {
        padding: 0 30px;
        margin-bottom: 20px;
        color: #999999;
        .fo {
          color: black;
          span {
            color: #2b68da;
          }
        }
        .co {
          text-align: right;
        }
      }
    }
    .hy_order {
      width: 100%;
      background-color: white;
      .div {
        padding-top: 40px;
        .order_title{
          display: block;
          margin: 0px 30px;
          font-size:30px;
          font-weight: 600;
          padding-left: 10px;
          line-height: 30px;
          border-left: 6px solid #189bff;
          .myIndex{
            float: right;
            font-size: 24px;
            color: #2b68da;

          }
        }
        >p {
          color: black;
          font-size: 30px;
          line-height: 40px;
          font-weight: 400;
          padding: 40px 30px;
          border-bottom: 2px solid #ebebeb;
        }
        >span {
          display: inline-block;
        }
        .order_list{
          width:100%;
          padding:0px 30px;
          border-bottom: 2px solid #ebebeb;
          .px_title{
            line-height: 35px;
            font-size: 28px;
            color: #333;
            padding-top: 20px;
          }
          >.van-row {
            font-size: 28px;
            line-height: 80px;
            overflow: hidden;
            letter-spacing: 3px;
            text-align: left;
            padding: 20px 0px;
            border-bottom: 2px dashed #ebebeb;
            .van-col {
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
              .imgbox{
                display: block;
                width: 70px;
                height: 70px;
                position: relative;
                vertical-align: middle;
                float: left;
                margin-right: 20px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  display: block;
                  border-radius: 50%;
                }
              }
              >p{
                font-size: 28px;
                color: #333;
                float: left;
                width: 250px;
                line-height: 70px;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
              .r{
                height: 70px;
                .span {
                  color: #f95d34;
                  font-size: 24px;
                  display: block;
                  line-height: 70px;
                  width: 100%;
                }
              }
              .tick {
                color: #f95d34;
                p {
                  width: 100%;
                  //padding: 0px 10px 0px 20px;
                  //  background-color: #ffe4dd;
                  margin: 0;
                  overflow: hidden; /*超出部分隐藏*/
                  white-space: nowrap; /*不换行*/
                  text-overflow: ellipsis; /*超出部分文字以...显示*/
                  line-height: 55px;
                  font-size: 26px;
                  font-weight: normal;
                  border-radius: 10px;
                  color: #f95d34;
                }
              }
              .r2{
                height: 55px;
                float: right;
                .span{
                  line-height: 55px;
                  font-size: 24px;
                  display: block;
                  width: 100%;
                  text-align: right;
                  color: #999;
                  &.active{
                    color:#2b68da
                  }
                }
              }
            }
            &:last-child{
              border-bottom: none;
            }
          }
          &:last-child{
            border-bottom: none;
          }
        }
      }
    }
    .meet_order {
      margin-top: 30px;
      background-color: white;
      .div {
        padding-top: 40px;
        width: 100vw;
        .op {
          font-weight: normal !important;
          font-size: 28px;
          padding: 20px 30px;
          overflow: hidden;
          color: #b2b2b2;
          width: 100%;
        }
      }
    }
    .hotels_order {
      margin-top: 30px;
      .div{
        width:100%;
        padding-top: 40px;
        .hotel_list{
          width:100%;
          padding:0px  30px;
          .hotel_item{
            width:100%;
            padding:30px  0px;
            border-bottom: 2px solid #ebebeb;
            .r2{
              float: right;
              text-align: right;
            }
            span {
              display: inline-block;
              &.active{
                color: #2b68da;
                font-size: 24px;
              }
            }
            .h_namebox{
              .h_name{
                margin-bottom: 10px;
                line-height: 40px;
                overflow: hidden;
                padding-left: 25px;
                position: relative;
                span{
                  position: absolute;
                  top: 12px;
                  left: 0px;
                  width: 14px;
                  height: 14px;
                  float: left;
                  display: block;
                  border-radius: 50%;
                  background: #f95d34;
                }
              }
              .r2{
                height: 40px;
                float: right;
                .span{
                  line-height: 40px;
                  font-size: 28px;
                  display: block;
                  width: 100%;
                  text-align: right;
                  color: #f95d34;
                }
              }
            }

            .h_time{
              color:#999999;
              margin-bottom: 10px;
              line-height: 40px;
              overflow: hidden;
              padding-left: 25px;
            }
            .list{
              padding: 10px 0px 0px 25px;
              .van-row {
                margin-bottom: 10px;
              }
            }
            &:last-child{
              border-bottom: none;
            }
          }
        }
      }
    }
  }
</style>
